import { DigitalClockPopupTranslations } from "./types";

export const deTranslations: DigitalClockPopupTranslations = {
    title: "Abgelaufene Zeit in dieser Schicht"
}